let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lIXAw")).then(() => parcelRequire('5DEq7'));